export default "__VITE_ASSET__Cnh7Mguq__"